<template>
  <router-link
    :to="{
      name: 'stacks.overview',
      params: { stack_id: stack.id },
    }"
  >
    <div class="row">
      <div class="col-12 col-lg-6 col-xl-6">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Comapny:</span>
          <span class="strong">{{ stack.client.company }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Name:</span>
          {{ stack.name }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Auto Bill:</span>
          <span
            v-bind:class="stack.auto_bill ? 'status-success' : 'status-mute'"
            class="status"
            >{{ stack.auto_bill ? 'Enabled' : 'Disabled' }}</span
          >
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    stack: {
      required: true,
      type: Object,
    },
  }
};
</script>
